<div style="display: flex; height: 100%; flex-direction: column; ">
	<!--this element is inserted cause the btn of esj schedule scrolls into view on click-->
	<div (click)="onNewEinsatz()" class="newEinsatzFakeBtn"></div>
  <div style="flex: 1; overflow: auto ;">
    <ejs-schedule #scheduleObj [timeFormat]="timeFormat" locale="de-CH" [dateFormat]="dateFormat" [firstDayOfWeek]="1" [selectedDate]="selectedDate" [eventSettings]="eventSettings" (popupOpen)="onPopupOpen($event)" (popupClose)="onPopupClose($event)" (eventClick)="onEventClick($event)"
      (navigating)="onNavigate($event)" (eventRendered)="onEventRendered($event)" [showQuickInfo]="showQuickInfo">
      <e-views>
        <e-view option="Week" startHour="07:00" endHour="20:00"></e-view>
        <e-view option="WorkWeek" startHour="07:00" endHour="20:00" isSelected="true"></e-view>
        <e-view option="Month" [showWeekend]="showWeekend"></e-view>
      </e-views>
      <ng-template #eventSettingsTemplate let-data>
        <div style="display: flex; flex-direction: column; padding: 4px">
          <div style="font-weight: bold;">{{ data.ObjectNumber }} {{ data.ObjectDescription }}</div>
          <div style="font-weight: bold;">{{ data.Note4}}</div>
          <div>{{ data.StartTime | date:'HH:mm' }} - {{ data.EndTime | date:'HH:mm' }}</div> 
          <div *ngIf="data.ProjectLeader">{{ "MAIN_APP_SERVICE_APP.agenda.projectLeader" | translate }}: {{ data.ProjectLeader }}</div> 
        </div>
      </ng-template>
    </ejs-schedule>

  </div>

  <footer class="agenda">
    <div>
      <span *ngIf="showRecordState === 2">
        <mat-icon class="icon-size" style="color:rgb(93, 194, 98)">
          schedule
        </mat-icon>
      </span>
      <span *ngIf="showRecordState === 3">
        <mat-icon class="icon-size" style="color:rgb(255, 193, 7)">
          coffee
        </mat-icon>
      </span>
      <span *ngIf="showRecordState">
        <div>
          <span *ngIf="currTimeRecordObjekt != undefined">
            {{ currTimeRecordObjekt!.objectNumber }}<br />
            {{ currTimeRecordObjekt!.description }}
          </span>
          <span *ngIf="currTimeRecordTermin != undefined">
            {{ currTimeRecordTermin.objectNumber }}<br />
            {{
            currTimeRecordTermin.objDescription +
            " " +
            formatDate(currTimeRecordTermin.startTime!)
            }}
          </span>
        </div>
      </span>
    </div>

    <div>
        <mat-icon class="icon-size" style="color:rgb(00, 00, 00)" (click)="startTimeRecording()" *ngIf="showRecordState === 1">
          play_circle
        </mat-icon>
        <mat-icon class="icon-size" style="color:rgb(236, 42, 42)" *ngIf="showRecordState === 2">
          play_circle
        </mat-icon>
        <mat-icon class="icon-size" style="color:rgb(00, 00, 00)" (click)="reStartTimeRecording()" *ngIf="showRecordState === 3">
          play_circle
        </mat-icon>
      <div>
        <div>{{ "MAIN_APP_SERVICE_APP.startzeit" | translate }} {{ startZeitRecording }}</div>

        <div> {{ "MAIN_APP_SERVICE_APP.auftragstotal" | translate }} {{ auftragsZeitTotal }}</div>
      </div>
    </div>

    <div>
        <mat-icon class="icon-size" style="color:rgb(236, 42, 42)" *ngIf="showRecordState === 3">
          pause
        </mat-icon>
        <mat-icon class="icon-size" style="color:rgb(00, 00, 00)" (click)="breakTimeRecording()" *ngIf="showRecordState === 2">
          pause
        </mat-icon>
        <mat-icon class="icon-size" style="color:rgb(155, 151, 151)" *ngIf="showRecordState === 1">
          pause
        </mat-icon>
        <mat-icon class="icon-size" *ngIf="showRecordState === 2 || showRecordState === 3" style="color:rgb(00, 00, 00)" (click)="stopTimeRecording()" >
          stop_circle
        </mat-icon>
        <mat-icon class="icon-size" style="color:rgb(155, 151, 151)" *ngIf="showRecordState === 1">
          stop_circle
        </mat-icon>
      <div>
        <div>Tagestotal {{ tagesTotal }}</div>
      </div>
    </div>
  </footer>
</div>
